// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"36e2480a","703":"a4fc8cab"}[chunkId] + ".chunk.js";
};